import { Image } from '@/modules/store/models/Image';
import { OrderPredictionItem } from '@/modules/store/models/OrderPredictionItem';
import { Amount, CalculatedPrice, Price } from '@/modules/store/models/Price';
import { Promotion } from '@/modules/store/models/Promotion';
import { Status } from '@/modules/store/models/Status';

export interface CartItem {
  id: number;
  productId?: string;
  skuId: string;
  supplierId: string;
  quantity: number;
  prediction?: OrderPredictionItem;
  checked?: boolean;
}

interface Sku {
  code: string;
  externalCode: string;
  moq: number;
  name: string;
  image?: Image;
  prices: Price[];
  promotions: Promotion[];
  status: Status;
}

export interface CartItemDetails extends CartItem {
  sku: Sku;
  price?: Amount;
  unitPrice?: CalculatedPrice;
  lineItemPrice?: CalculatedPrice;
  vatRate: number;
  vatAmount: Amount;
}

export class CartItemImpl implements CartItem {
  id: number = 0;
  readonly productId?: string;
  readonly skuId: string;
  readonly supplierId: string;
  readonly quantity: number;
  readonly prediction?: OrderPredictionItem;
  checked?: boolean;

  constructor(
    skuId: string,
    supplierId: string,
    quantity: number,
    prediction?: OrderPredictionItem,
    checked?: boolean,
  ) {
    this.skuId = skuId;
    this.supplierId = supplierId;
    this.quantity = quantity;
    this.prediction = prediction;
    this.checked = checked;
  }

  static fromObject(obj: CartItem): CartItemImpl {
    const cartItem = new CartItemImpl(
      obj.skuId,
      obj.supplierId,
      obj.quantity,
      obj.prediction,
      obj.checked,
    );

    cartItem.id = obj.id;

    return cartItem;
  }
}
